import { Alert, Box, styled } from '@mui/material';

export const NumberContainer = styled(Box)(
  ({ theme, selected }) => `
      background-color: ${theme.palette.primary.main};
      display: inline-flex;
      justify-content: center;
      align-items: center;
      height: 25px;
      width: 25px;
      font-size: 14px;
      color: ${theme.palette.primary.lightest};
      border-radius: 1000px;
      margin-right: 8px;
      ${
        selected &&
        `
          background-color: ${theme.palette.secondary.light};
      `
      }
  `,
);

export const Container = styled('div')({
  marginLeft: '30px',
});

export const MarginFormControlLabel = styled('div')({
  paddingLeft: '20px',
  paddingRight: '2px',
});

export const AlertMessage = styled(Alert)({
  textAlign: 'center',
});
